module.exports = __webpack_public_path__ + "static/media/27-7.e34f85c9.mp3";